var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._g(
      _vm._b(
        {
          ref: "dragSelect",
          staticClass: "drag-select",
          attrs: { multiple: "" },
          model: {
            value: _vm.selectVal,
            callback: function($$v) {
              _vm.selectVal = $$v
            },
            expression: "selectVal"
          }
        },
        "el-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }